import { render, staticRenderFns } from "./AdminConfigUI.vue?vue&type=template&id=957d63ba&scoped=true"
import script from "./AdminConfigUI.vue?vue&type=script&lang=js"
export * from "./AdminConfigUI.vue?vue&type=script&lang=js"
import style0 from "./AdminConfigUI.vue?vue&type=style&index=0&id=957d63ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957d63ba",
  null
  
)

export default component.exports